import { BrokernetProductName } from '@base/backend';

export enum InsuranceTypeEnum {
  BIKE = 'BIKE',
  ELEKTRONIK = 'ELEKTRONIK',
  KAUFPREIS = 'KAUFPREIS',
  GARANTIE = 'GARANTIE'
}

export const ServoProductNameTranslations = {
  getTypeTranslation(insuranceType: BrokernetProductName) {
    switch (insuranceType) {
      case BrokernetProductName.ServoBikeEBike:
        return 'Fahrrad/E-Bike';
      case BrokernetProductName.ServoElektronik:
        return 'Elektronik';
      case BrokernetProductName.ServoKaufpreisKasko:
        return 'Kaufpreiskasko';
      case BrokernetProductName.ServoGarantieverlaengerung:
        return 'Garantieverlängerung';
      default:
        return '';
    }
  }
};
